import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { CacheService } from 'app-service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  // Define an array of routes to block
  private blockedRoutes: string[] = [
    '/assets/i18n/en.json',
    '/account/sign-up'
  ];

  public constructor(private readonly _cacheService: CacheService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.isBlockedRoute(request.url)) {
      // If the request matches a blocked route, simply pass it without attaching the token
      return next.handle(request);
    }
    // Get the access token from wherever it is stored (localStorage, cookies, etc.)
    const accessToken = this._cacheService.getItem('token');

    // Clone the request and attach the access token to the Authorization header
    const authRequest = request.clone({
      setHeaders: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    // Pass the cloned request to the next handler
    return next.handle(authRequest);
  }

  private isBlockedRoute(url: string): boolean {
    // Check if the request URL matches any of the blocked routes
    return this.blockedRoutes.some((route) => url.includes(route));
  }
}
